import React, { createContext, useContext, useEffect, useState, useRef } from "react";
import { C4FStatusContext, INIT_STATUS_COMPLETED, ReferenceDataContext } from "./App";

// set the defaults
const LocalizationContext = createContext({
  getLocalizedText: () => { }
});

const LocalizationContextProvider = ({ children }) => {
  // the value that will be given to the context
  const { language, initialized } = useContext(C4FStatusContext);
  const { localizationCommon, localizationNavigation, localizationRace, localizationReferenceData, localizationTransfermarket } = useContext(ReferenceDataContext);

  function getLocalizedText(group, id) {
    if (initialized !== INIT_STATUS_COMPLETED) return id;
    
    let localizationGroup = null;
    switch (group) {
      case 'common': localizationGroup = localizationCommon;break;
      case 'navigation': localizationGroup = localizationNavigation;break;
      case 'race': localizationGroup = localizationRace;break;
      case 'referenceData': localizationGroup = localizationReferenceData;break;
      case 'transfermarket': localizationGroup = localizationTransfermarket;break;
      default: throw new Error('Unknown localization group ' + group);
    }

    if (!localizationGroup.some(li => li.id === id)) {
      return 'unknown';
    }
    let localizedTexts = localizationGroup.find(li => li.id === id).localizedText;

    // return the requested language or EN as default
    if (language in localizedTexts) return localizedTexts[language];
    else return localizedTexts['EN'];
  }

  return (
    <LocalizationContext.Provider value={{
      getLocalizedText
    }}>
      {children}
    </LocalizationContext.Provider>
  );
}
export { LocalizationContext, LocalizationContextProvider };

